import React from "react";

const SvgArrowUp = props => <svg viewBox="0 0 20 20" {...props}><defs><path id="arrow_up_svg__a" d="M11 17V5.414l3.293 3.293a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a.996.996 0 0 0 0 1.414 1 1 0 0 0 1.414 0L9 5.414V17a1 1 0 1 0 2 0" /></defs><use fill="#647482" fillRule="evenodd" xlinkHref="#arrow_up_svg__a" /></svg>;

export default SvgArrowUp;